import React from 'react'
import { useMemo } from 'react';
import { useTaskDefs } from '../data/task';
export const useTaskNames = () => {
    const {
        data: tasks,
        isFetching: isFetchingTasks,
        refetch: refetchTasks
    } = useTaskDefs();

    // Computed values
    const taskNames = useMemo(() => {
        if (!Array.isArray(tasks)) return [];
        const names = tasks.map((task) => task.name.trim());
        return Array.from(new Set(names));
    }, [tasks, isFetchingTasks]);

    return {
        taskNames,
        refetchTasks,
        isFetchingTasks
    }
}
